import { List } from 'antd';
import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'redux';
import { LoadingOutlined } from '@ant-design/icons';
import { ApplicationState } from '../../../store';
import { loadRequest } from '../../../store/ducks/products/actions';
import ProductListItem from '../ProductListItem';
import { scroll } from '../../../store/ducks/layout/actions';
interface Props {
  mode?: 'GRID' | 'IMAGEM' | 'CARD';
}
const ProductList: React.FC<Props> = ({ mode }) => {
  const layout = useSelector((state: ApplicationState) => state.layout.data);
  const data = useSelector((state: ApplicationState) => state.products.data);
  const pagination = useSelector((state: ApplicationState) => state.products.pagination);
  const loading = useSelector((state: ApplicationState) => state.products.loading);
  const advancedFilters = useSelector((state: ApplicationState) => state.products.advancedFilters);
  const filter = useSelector((state: ApplicationState) => state.products.filter);
  const dispatch = useDispatch<Dispatch<Action>>();

  return (
    <List
      loading={{
        style: { color: layout?.color.default },
        spinning: loading,
        size: 'large',
        delay: 500,
        indicator: <LoadingOutlined style={{ fontSize: 24 }} spin />,
      }}
      dataSource={data}
      pagination={{
        size: 'small',
        ...pagination,
        onChange: (page, pageSize) => {
          dispatch(loadRequest(filter, undefined, {
            current: page,
            pageSize: pageSize || 0,
            total: pagination?.total || 0,
          }, undefined, advancedFilters));
          dispatch(scroll());
        },
      }}
      renderItem={(item) => {
        return <ProductListItem item={item} mode={mode} loading={loading} />;
      }}
    />
  );
};

export default ProductList;
